import React, { Fragment, useMemo } from 'react'
import classNames from 'classnames'

import TmoH3 from '../../tmoControlWrappers/TmoH3'

import style from './PaginationCounts.module.css'
import stringUtils from '../../tmoUtilities/string'

function PaginationCounts({
  showPagination,
  data,
  dataType,
  currentPage,
  pageSize,
  resultsToShow,
  totalItems,
  from,
  to,
  isPrimary
}) {
  const fromRecords = useMemo(() => (totalItems === 0 ? 0 : from + 1), [
    totalItems,
    from
  ])

  const toRecords = useMemo(
    () =>
      data.length < resultsToShow
        ? currentPage * pageSize + data.length
        : to + 1,
    [data, resultsToShow, currentPage, pageSize, to]
  )

  return (
    <div className={style.container}>
      {totalItems > 1 && (
        <TmoH3
          className={classNames(
            style.heading,
            isPrimary && style.primary_heading
          )}
          flush
        >
          {isPrimary ? (
            <span className={style.item_count}>
              {totalItems?.toLocaleString()}{' '}
            </span>
          ) : (
            <Fragment>{totalItems?.toLocaleString()} </Fragment>
          )}
          <span className={style.data_type}>
            {dataType &&
              stringUtils
                .pluralize({ string: dataType, count: totalItems })
                .toLowerCase()}
          </span>{' '}
          Found
        </TmoH3>
      )}
      {showPagination && (
        <span
          className={classNames(style.count, isPrimary && style.primary_count)}
        >
          Displaying results {fromRecords} - {toRecords}
        </span>
      )}
    </div>
  )
}

export default PaginationCounts
